import * as yup from 'yup';

import { POSITIVE, REQUIRED } from '../errorsText';
import { STORE_DEFAULT } from '../../pages/constants';

export const validationFields = {
  amount: yup.number().positive(POSITIVE).required(REQUIRED),
  description: yup.string().required(REQUIRED),
  messageId: yup.string().required(REQUIRED),
  messages: yup.array(),
  email: yup.string(),
  emails: yup.array(),
  storeIdEq: yup.string().required(REQUIRED),
  comment: yup.string().required(REQUIRED),
  scheduleAt: yup.string(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (messages, stores) => {
  const storeValue = stores
    ?.filter((item) => item?.name?.includes(STORE_DEFAULT))
    .map((item) => item.id)[0];
  const initialValues = {
    amount: 0,
    description: '',
    messageId: '',
    messages: messages,
    email: '',
    emails: [],
    storeIdEq: storeValue,
    comment: '',
    scheduleAt: '',
  };

  return initialValues;
};
